import React, { useEffect } from 'react';
import BaseNewsPrompt from '../BaseNewsPrompt/BaseNewsPrompt';


interface SpeiNewsPromptProps {
    shouldShow: boolean;
    onClose?: () => void;
}

const SpeiNewsPrompt = ({
    shouldShow,
    onClose,
}: SpeiNewsPromptProps) => {
    const [hasSeenPrompt, setHasSeenPrompt] = React.useState(false);

    useEffect(() => {
        const hasSeen = !!localStorage.getItem('__news_spei_stripe')
        setHasSeenPrompt(hasSeen);
    }, []);

    const saveOnClose = () => {
        // Save to local storage
        localStorage.setItem('__news_spei_stripe', 'true');
        setHasSeenPrompt(true);
        onClose && onClose();
    }

    return (
        <BaseNewsPrompt
            openTrigger={shouldShow && !hasSeenPrompt}
            onClose={saveOnClose}
            title='Cambios en Pagos SPEI y CLABE destino'
            closeText='¡Entendido!'
        >
            <div className='row'>
                <p>
                    <b>Derivado de la separación de Citibanamex, su CLABE para pagos SPEI ha cambiado.</b>
                </p>
                <p>
                    Solicitamos que actualice la CLABE para abono de saldo a FiscalPOP con la nueva información, misma que <span className='warning'>se proporcionará al solicitar un nuevo pago por SPEI.</span>
                </p>
                <p>
                    Esta nueva CLABE SPEI debe empezar con "124" y podrá ser guardada para futuros pagos.
                </p>
                <br />
                <p><b>¿Que sucede si me equivoqué de CLAVE y usé la anterior?</b></p>
                <p>
                    En caso que haya realizado un pago a la CLABE anterior, no se preocupe, el dinero será rechazado y regresado a su cuenta en un plazo menor a 24 horas.
                </p>
            </div>

        </BaseNewsPrompt>
    )
}

export default SpeiNewsPrompt;